import { useContext } from "react";
import { LocaleContext } from "../utils/LocaleContext";
import { useStores } from "../stores/useStores";

export function useTranslateClassName() {
  let locale = useContext(LocaleContext);
  const { i18nStore } = useStores();

  const shouldTranslate = locale !== i18nStore.googleCode;

  return shouldTranslate ? "" : "notranslate";
}
